import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import './Header.css';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="header__container">
        <div className="header__logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <Logo size={40} />
          <span className="header__logo-text">Hirexio</span>
        </div>
        <nav className="header__nav">
          <button className="header__link" onClick={() => scrollTo('services')}>
            Services
          </button>
          <button className="header__link" onClick={() => scrollTo('contact')}>
            Contact
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
